module.exports = __webpack_public_path__ + "img/full6-min.a47678d3.png";